import { useMutation } from 'react-query'

import { queryClient } from '../..'
import api from '../../services/api'

export default function useCreateEquipmentType() {
  return useMutation(
    (values) => api.post('/equipment-type', values).then((res) => res.data),
    {
      onSuccess: () => queryClient.invalidateQueries('equipmentTypes'),
    }
  )
}